module.exports = __webpack_public_path__ + "static/media/Bubbly_ios_1.86e9e827.jpg";